import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function extractBiometry(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/extract-biometry", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function calculate(payload) {
  const { data } = await api.post("/calculate", payload);
  return data;
}

export async function saveHistory(entry) {
  const { data } = await api.post("/history", entry);
  return data;
}

export async function listHistory() {
  const { data } = await api.get("/history");
  return data;
}

export async function deleteHistory(id) {
  const { data } = await api.delete(`/history/${id}`);
  return data;
}

export async function patchHistory(id, payload) {
  const { data } = await api.patch(`/history/${id}`, payload);
  return data;
}

export async function downloadReportPdf(request, result) {
  const { data } = await api.post("/report/pdf", { request, result }, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `IOL_report_${(request.patient_name || "report").trim().replace(/\s+/g, "_")}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function getOutcomes() {
  const { data } = await api.get("/outcomes");
  return data;
}

export async function getSurgeonFactor() {
  const { data } = await api.get("/surgeon-factor");
  return data;
}
